// extracted by mini-css-extract-plugin
module.exports = {"center":"SectionTitle_center__VC7Q4","left":"SectionTitle_left__oh4hB","right":"SectionTitle_right__6CX0K"};